import { ElementRef } from '@angular/core';
import { EventEmitter } from '@angular/core';
var UIOptionComponent = /** @class */ (function () {
    function UIOptionComponent(_elementRef) {
        this._elementRef = _elementRef;
        this.onSelectOption = new EventEmitter();
    }
    Object.defineProperty(UIOptionComponent.prototype, "viewValue", {
        get: function () {
            return this._elementRef.nativeElement.textContent.trim();
        },
        enumerable: true,
        configurable: true
    });
    UIOptionComponent.prototype.selectOption = function () {
        if (this.disabled === undefined) {
            this.onSelectOption.emit(this);
        }
    };
    return UIOptionComponent;
}());
export { UIOptionComponent };
